import React from "react";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import styles from "./Home.module.css";
import logo from "../../images/OrangeLogo-box.png"; // Importing the logo

const Home = () => {
  return (
    <div className={styles.container}>
      <img src={logo} alt="Logo" className={styles.logo} />{" "}
      {/* Logo at the top */}
      <h2 className={styles.title}>✨ Post. Connect. Buy. Sell!</h2>
      <p className={styles.description}>
        Whether you're looking to share moments, promote a service, sell your
        old items, or find what you need Rasel Media makes it simple,
        interactive, and community-driven
      </p>
      <div className={styles.buttons}>
        <a
          href="https://play.google.com/store/apps/details?id=com.raselmedia"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.storeButton}
        >
          <FaGooglePlay className={styles.icon} />
          <span>Google Play</span>
        </a>
        <a
          href="https://apps.apple.com/in/app/rasel-media/id6502615878"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.storeButton}
        >
          <FaApple className={styles.icon} />
          <span>App Store</span>
        </a>
      </div>
      <div className={styles.infoSection}>
        <h3>🔒 Privacy & Policy</h3>
        <p>
          We take your privacy seriously. Your data is kept confidential and is
          never shared without consent.
        </p>

        <h3>💡 About Us</h3>
        <p>
          Rasel Media is more than just a social platform — it’s a vibrant hub
          where connections turn into opportunities.
        </p>

        <h3>📩 Contact Us</h3>
        <p>
          Email us at{" "}
          <a href="mailto:info@raselmedia.com" className={styles.email}>
            info@raselmedia.com
          </a>
        </p>
      </div>
      {/* Icon Credits */}
      <div className={styles.credits}>
        <p>
          Icons by{" "}
          <a
            href="https://react-icons.github.io/react-icons/"
            target="_blank"
            rel="noopener noreferrer"
          >
            React Icons
          </a>
        </p>
      </div>
    </div>
  );
};

export default Home;
